import React from 'react'
import styled from 'styled-components'

import { Label, LabelProps } from './Label'
import { InputValue, InputValueProps } from './InputValue'
import { ListOptions, ListOptionsProps } from './ListOptions'

export interface ConvertUomProps {
    inputProps: InputValueProps
    optionProps: ListOptionsProps
    labelProps: LabelProps
    id?: string
    propWidth?: number
}

export function ConvertUom({ inputProps, optionProps, labelProps, id, propWidth }: ConvertUomProps): JSX.Element {
    return (
        <ThrottleContainer key={id} propWidth={propWidth}>
            <div className="titleContainer">
                <Label
                    className={labelProps?.className}
                    required={labelProps?.required}
                    tooltip={labelProps?.tooltip}
                    title={labelProps.title}
                />
                <InputValue
                    value={inputProps.value}
                    defaultValue={inputProps.defaultValue}
                    placeholder={inputProps.placeholder}
                    className={inputProps.className}
                    onChange={inputProps.onChange}
                    type={inputProps.type}
                />
            </div>
            <ListOptions
                options={optionProps.options}
                required={optionProps.required}
                className={optionProps.className}
                closeMenuOnSelect={optionProps.closeMenuOnSelect}
                defaultValue={optionProps.defaultValue}
                editMode={optionProps.defaultValue}
                hideSelectedOptions={optionProps.hideSelectedOptions}
                isClearable={optionProps.isClearable}
                isMulti={optionProps.isMulti}
                isSearchable={optionProps.isSearchable}
                placeholder={optionProps.placeholder}
                styles={optionProps.styles}
                value={optionProps.value}
                onChange={optionProps.onChange}
            />
        </ThrottleContainer>
    )
}

// interface ThrottleContainerProps {
//     propWidth?: number
// }

const ThrottleContainer = styled.div<{ propWidth: number }>`
    width: ${props => props.propWidth || 100}%;
    margin-top: 16px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;

    .titleContainer {
        display: grid;
        flex-direction: column;
        width: 100%;

        .throttle-title {
            display: flex;
            padding-bottom: 8px;
            span {
                font-style: normal;
                font-weight: 600;
                font-size: 13px;
                line-height: 16px;
            }
        }
    }
`
